export enum LinkTypesEnums {
  WEBSITE = 'website',
  GITHUB = 'github',
  BEHANCE = 'behance',
  DRIBBBLE = 'dribble',
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
}